<a mat-button [href]="sanitizedUrl" target="_blank">
  @if (isExternalLink) {
    <fa-icon [icon]="['fas', 'external-link-alt']" [fixedWidth]="true"></fa-icon>
  }
  @if (!isExternalLink) {
    <mat-icon color="primary">chevron_right</mat-icon>
  }
  {{ label }}
</a>
